import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Stack,
  Skeleton,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import UserAPI from "../../../../apis/UserAPI";
import { useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { useHistory } from "react-router-dom";

const PaymentOrder = () => {
  const history = useHistory();
  const { orderId: rawOrderId } = useParams() as any;
  const orderId =
    typeof rawOrderId === "string" && rawOrderId !== "" && rawOrderId.length > 0
      ? rawOrderId
      : null;

  const [isLoading, setIsLoading] = useState(true);
  const [courseId, setCourseId] = useState<string>('');
  const [email, setEmail] = useState<string>('-');
  const [autogeneratedPassword, setAutogeneratedPassword] =
    useState<string>("-");

  useEffect(() => {
    const unsubscribe = UserAPI.subscribeToOrderId(
      orderId,
      (data: any) => {
        setIsLoading(true);
        const email = data?.studentEmail;

        if (typeof email !== "string") {
          setEmail("-");
          setAutogeneratedPassword("-");
          setCourseId("");
          return;
        }
        setEmail(email);
        const hasUser = typeof data?.userId === 'string' && data.userId !== '';
        if (hasUser) {
          const autogeneratedPassword = data?.autogeneratedPassword ?? undefined;
          if (
            typeof autogeneratedPassword === "string" &&
            autogeneratedPassword !== "" &&
            autogeneratedPassword.length > 0
          ) {
            setAutogeneratedPassword(autogeneratedPassword);
          } else {
            setAutogeneratedPassword("-");
          }

          const courseId = data?.courseId ?? undefined;
          if (
            typeof courseId === "string" &&
            courseId !== "" &&
            courseId.length > 0
          ) {
            setCourseId(courseId);
          } else {
            setCourseId("");
          }
        }

        if (hasUser) {
          setIsLoading(false);
        } else {
          setIsLoading(true);
        }
      }
    );
    return () => {
      unsubscribe();
    };
  }, [orderId]);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: 24,
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: 400 }}>
        <Stack spacing={4}>
          <Typography variant="h5" textAlign="center" fontWeight={500}>
            Transacción exitosa
          </Typography>
          <Stack spacing={2}>
            <Stack spacing={1}>
              <Alert severity="success">
                ¡Felicitaciones! El curso está activado
              </Alert>
              <Alert severity="info">
                Si necesitas ayuda, llámanos o escríbenos al{" "}
                <span style={{ whiteSpace: "nowrap" }}>+51 975 400 190</span> o
                a{" "}
                <span style={{ whiteSpace: "nowrap" }}>
                  RaDi-languages@t-online.de
                </span>
                . ¡Con mucho gusto te apoyamos!
              </Alert>
            </Stack>
            {isLoading ? (
              <Stack spacing={2}>
                <Skeleton animation="pulse" variant="rounded" height={50} />
                <Skeleton animation="pulse" variant="rounded" height={50} />
                <Skeleton animation="pulse" variant="rounded" height={50} />
              </Stack>
            ) : (
              <Stack spacing={3}>
                <Stack spacing={1}>
                  <Typography variant="h6" textAlign="left" fontWeight={500}>
                    Correo
                  </Typography>
                  <Typography variant="body1" textAlign="left">
                    {email}
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography variant="h6" textAlign="left" fontWeight={500}>
                    Contraseña
                  </Typography>
                  <Typography variant="body1" textAlign="left">
                    {autogeneratedPassword}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Stack>
          {!isLoading && (
            <Button
              variant="contained"
              sx={{ p: 2 }}
              onClick={() => {
                history.push(`/${courseId}`);
              }}
            >
              Ir al curso
            </Button>
          )}
        </Stack>
      </div>
    </div>
  );
};

export { PaymentOrder };
